(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wm-scarcity"] && !Shopify.designMode) return;
  try {
    (function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init() {
    document.querySelectorAll('.wm-sof').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var hrs = parseInt(el.getAttribute('data-hours'), 10) || 0;
      var mins = parseInt(el.getAttribute('data-mins'), 10) || 0;
      var total = hrs * 3600 + mins * 60;
      if (total <= 0) total = 3 * 3600;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var rem = total;
      function render() {
        if (h) h.textContent = pad(Math.floor(rem / 3600));
        if (m) m.textContent = pad(Math.floor((rem % 3600) / 60));
        if (s) s.textContent = pad(rem % 60);
      }
      render();
      setInterval(function () { rem--; if (rem < 0) { rem = total; } render(); }, 1000);
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wm-ship-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init() {
    document.querySelectorAll('.wm-ship').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var d = el.querySelector('.wm-ship__date[data-auto]');
      if (d) {
        try { d.textContent = new Date().toLocaleDateString(undefined, { month: 'long', day: 'numeric' }); }
        catch (e) { d.textContent = new Date().toDateString(); }
      }
      var minutes = parseInt(el.getAttribute('data-minutes'), 10);
      if (!minutes || minutes < 1) minutes = 5;
      var total = minutes * 60;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var rem = total;
      function render() {
        if (h) h.textContent = Math.floor(rem / 3600);
        if (m) m.textContent = Math.floor((rem % 3600) / 60);
        if (s) s.textContent = pad(rem % 60);
      }
      render();
      setInterval(function () { rem--; if (rem < 0) { rem = total; } render(); }, 1000);
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
  } catch(e) { console.error(e); }
})();

})();
